export const dateInPast = (date: any): boolean => {
  if (typeof date === "number") {
    return date < Date.now();
  }
  return new Date(date).getTime() < Date.now();
};
